<template>
  <div v-if="show_body" class="bg-pick">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="info-img pr">
      <img src="@a/my-resentation.png" alt />
      <p class="poster-tipH text-yellow text-bold pa">可迁移能力报告</p>
      <div class="poster-tip text-yellow text-bold pa" v-if="isMy">(完整版)</div>
      <div class="poster-tip text-yellow text-bold pa" v-else>(自评版)</div>
    </div>
    <div class="con-box pr">
      <div v-if="isMy">
        <div class="banner-box">
          <div class="banner-title pr text-center">
            <div class="pa ban-header-bg"></div>
            <span class="pr">他评报告</span>
          </div>
        </div>
        <div class="con-cart">
          <div class="intro-1">
            <div class="cart-footer">“以人为镜，可以知得失”</div>
            <p class="pt34">
              现在已有
              <span class="text-yellow">{{ ta_count }}人</span> 对您的能力进行了反馈，他评结果与自评结果对比如下所示。在解读时，能力绝对值反映能力高低；差异值反映自我和他人的评分差异。
            </p>
            <p></p>
            <!--  -->
            <!-- 						<div class="mt34 pr item-ol">
							<p class="pr">绝对值：得分越高表示能力评价越高。</p>
							<p class="pr">差异值：自评与他评得分的差异，差异较大的能力需要重视，思考产生差异的原因，判断是否采取相关行动改善。</p>
            </div>-->
            <!--  -->
            <div class="loss-100 charts-box">
              <ve-radar
                :height="'420px'"
                :data="taRadarData1"
                :colors="['rgba(255,255,255,0)', '#ED7D31', '#4372C4']"
                :extend="radarExtend"
              ></ve-radar>
              <!-- :settings="radarChartStyle1" -->
            </div>
            <!-- <div class="cart-footer">接下来我们进行针对性分析</div> -->
          </div>
        </div>
        <!-- 横幅 -->
        <div class="banner-box">
          <div class="banner pr text-center">
            <div class="p-l pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <div class="p-r pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <p>自评他评总体对比</p>
          </div>
        </div>
        <!--  -->
        <div class="con-cart">
          <div class="intro-1">
            <p>四个维度能力的自评与他评对比如下图所示（分值范围1-5分）：</p>
            <div class="lin-charts-box bar-pa charts-box">
              <ve-bar
                :height="'280px'"
                :data="taBarData1"
                :colors="['#ED7D31', '#4372C4']"
                :settings="taBarConfig"
              ></ve-bar>
            </div>
            <!--  -->
            <div v-if="ta_high.length">
              <p class="pt34">高估提示（您认为不错，可能未被他人看到的能力，下同）：</p>
              <div class="tag-row">
                <span v-for="item in ta_high" :key="item">{{item}}</span>
              </div>
            </div>
            <div v-if="ta_low.length">
              <p class="pt34 mt34">低估提示（您实际表现不错，但自己没意识到的能力，下同）：</p>
              <div class="tag-row">
                <span v-for="item in ta_low" :key="item">{{item}}</span>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="public-cart rgb-cart-box">
          <div
            @click="cartState2 = !cartState2"
            :class="[cartState2 ? 'tr' : '' ,'scroll-ico mt34 text-center']"
          >
            <img src="@a/down-scroll.png" alt />
          </div>
          <p v-show="!cartState2" class="text-yellow mt34 text-center">点击查看各项能力对比</p>
          <p v-show="cartState2" class="text-yellow mt34 text-center">点击收起各项能力对比</p>
        </div>
        <!-- 横幅 -->
        <div v-if="cartState2" class="banner-box">
          <div @click="cartState2 = !cartState2" class="banner pr text-center">
            <div class="p-l pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <div class="p-r pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <p>各项能力对比</p>
          </div>
        </div>
        <!--  -->
        <div v-if="cartState2" class="con-cart">
          <div class="intro-1">
            <p>本部分将四个维度12项能力的他评与自评结果分别进行对比，如下图所示：</p>
            <div class="visual">
              <div class="pr vis-name">
                <span class="line pa"></span>
                <h4>[1 思维能力]</h4>
              </div>
            </div>
            <div class="lin-charts-box charts-box">
              <ve-bar
                :height="'280px'"
                :data="taBarData2"
                :colors="['#ED7D31', '#4372C4']"
                :settings="taBarConfig"
              ></ve-bar>
            </div>
            <div v-if="twoRadarResult1.ta_high" class="lin-tag mt34">
              您在
              <span v-for="(item,index) in twoRadarResult1.ta_high" :key="index">{{item}}</span>方面的实际表现比您自我评价的要好；
            </div>
            <div v-if="twoRadarResult1.ta_low" class="lin-tag mt34">
              您在
              <span v-for="(item,index) in twoRadarResult1.ta_low" :key="index">{{item}}</span>方面的实际表现可能不如您自评的那样好；
            </div>
            <div v-if="twoRadarResult1.ta_eq" class="lin-tag mt34">
              您对
              <span v-for="(item,index) in twoRadarResult1.ta_eq" :key="index">{{item}}</span>的自评结果与他评结果一致；
            </div>

            <div class="visual mt34">
              <div class="pr vis-name">
                <span class="line pa"></span>
                <h4>[2 人际能力]</h4>
              </div>
            </div>
            <div class="lin-charts-box charts-box">
              <ve-bar
                :height="'280px'"
                :data="taBarData3"
                :colors="['#ED7D31', '#4372C4']"
                :settings="taBarConfig"
              ></ve-bar>
            </div>
            <div v-if="twoRadarResult2.ta_high" class="lin-tag mt34">
              您在
              <span v-for="(item,index) in twoRadarResult2.ta_high" :key="index">{{item}}</span>方面的实际表现比您自我评价的要好；
            </div>
            <div v-if="twoRadarResult2.ta_low" class="lin-tag mt34">
              您在
              <span v-for="(item,index) in twoRadarResult2.ta_low" :key="index">{{item}}</span>方面的实际表现可能不如您自评的那样好；
            </div>
            <div v-if="twoRadarResult2.ta_eq" class="lin-tag mt34">
              您对
              <span v-for="(item,index) in twoRadarResult2.ta_eq" :key="index">{{item}}</span>的自评结果与他评结果一致；
            </div>

            <div class="visual mt34">
              <div class="pr vis-name">
                <span class="line pa"></span>
                <h4>[3 任务管理 ]</h4>
              </div>
            </div>
            <div class="lin-charts-box charts-box">
              <ve-bar
                :height="'280px'"
                :data="taBarData4"
                :colors="['#ED7D31', '#4372C4']"
                :settings="taBarConfig"
              ></ve-bar>
            </div>
            <div v-if="twoRadarResult3.ta_high" class="lin-tag mt34">
              您在
              <span v-for="(item,index) in twoRadarResult3.ta_high" :key="index">{{item}}</span>方面的实际表现比您自我评价的要好；
            </div>
            <div v-if="twoRadarResult3.ta_low" class="lin-tag mt34">
              您在
              <span v-for="(item,index) in twoRadarResult3.ta_low" :key="index">{{item}}</span>方面的实际表现可能不如您自评的那样好；
            </div>
            <div v-if="twoRadarResult3.ta_eq" class="lin-tag mt34">
              您对
              <span v-for="(item,index) in twoRadarResult3.ta_eq" :key="index">{{item}}</span>的自评结果与他评结果一致；
            </div>

            <div class="visual mt34">
              <div class="pr vis-name">
                <span class="line pa"></span>
                <h4>[4 团队管理 ]</h4>
              </div>
            </div>
            <div class="lin-charts-box charts-box">
              <ve-bar
                :height="'280px'"
                :data="taBarData5"
                :colors="['#ED7D31', '#4372C4']"
                :settings="taBarConfig"
              ></ve-bar>
            </div>
            <div v-if="twoRadarResult4.ta_high" class="lin-tag mt34">
              您在
              <span v-for="(item,index) in twoRadarResult4.ta_high" :key="index">{{item}}</span>方面的实际表现比您自我评价的要好；
            </div>
            <div v-if="twoRadarResult4.ta_low" class="lin-tag mt34">
              您在
              <span v-for="(item,index) in twoRadarResult4.ta_low" :key="index">{{item}}</span>方面的实际表现可能不如您自评的那样好；
            </div>
            <div v-if="twoRadarResult4.ta_eq" class="lin-tag mt34">
              您对
              <span v-for="(item,index) in twoRadarResult4.ta_eq" :key="index">{{item}}</span>的自评结果与他评结果一致；
            </div>
          </div>
        </div>
        <!-- 横幅 -->
        <div class="banner-box">
          <div class="banner pr text-center">
            <div class="p-l pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <div class="p-r pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <p>共识与盲点能力</p>
          </div>
        </div>
        <!--  -->
        <div class="con-cart">
          <div class="intro-1">
            <p>结合自评和他评结果，我们将您的12项能力划分到四个区，如下所示。</p>
            <!-- 表 -->
            <div class="d-box">
              <div class="table-data mt34 pr">
                <div class="coll-t pr">
                  <div class="table-l-type">
                    <div>
                      <div>
                        他
                        <br />评
                        <br />较
                        <br />高
                      </div>
                    </div>
                    <div>
                      <div>
                        他
                        <br />评
                        <br />较
                        <br />低
                      </div>
                    </div>
                  </div>
                  <div class="table-con">
                    <div>
                      <span>优势盲点区</span>
                      <div class="clearfix">
                        <p
                          class="pull-left"
                          v-for="(item,index) in tabList['优势盲点区']"
                          :key="index"
                        >{{item}}</p>
                      </div>
                    </div>
                    <div>
                      <span>优势共识区</span>
                      <div class="clearfix">
                        <p
                          class="pull-left"
                          v-for="(item,index) in tabList['优势共识区']"
                          :key="index"
                        >{{item}}</p>
                      </div>
                    </div>
                    <div>
                      <span>劣势共识区</span>
                      <div class="clearfix">
                        <p
                          class="pull-left"
                          v-for="(item,index) in tabList['劣势共识区']"
                          :key="index"
                        >{{item}}</p>
                      </div>
                    </div>
                    <div>
                      <span>劣势盲点区</span>
                      <div class="clearfix">
                        <p
                          class="pull-left"
                          v-for="(item,index) in tabList['劣势盲点区']"
                          :key="index"
                        >{{item}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="coll-b table-r-type">
                  <div class="coll-b-con">
                    <div>自评较低</div>
                    <div>自评较高</div>
                  </div>
                </div>
              </div>
            </div>
            <!--  -->
            <p class="text-yellow mt34">值得注意的是：各区均为相对您自己各项能力比较的结果，并不是与他人能力比较的结果。</p>

            <!-- <p class="mt34">如果有能力刚好落在中间线上，请根据自己的实际情况 进行归类。</p> -->

            <h3 class="two-title mt34 text-bold">3.1 您的优势共识区：</h3>
            <div class="tag-row">
              <span v-for="(item1, index) in detail['优势共识区'].result" :key="index+''">{{item1}}</span>
              <span v-if="detail['优势共识区'].result.length == 0">（无）</span>
            </div>
            <div v-if="detail['优势共识区'].report.length" class="mt34 pr item-ol">
              <p class="pr">{{detail["优势共识区"].report}}</p>
            </div>

            <h3 class="two-title mt34 text-bold">3.2 您的劣势共识区：</h3>
            <div class="tag-row">
              <span v-for="(item2, index) in detail['劣势共识区'].result" :key="index+''">{{item2}}</span>
              <span v-if="detail['劣势共识区'].result.length == 0">（无）</span>
            </div>
            <div v-if="detail['劣势共识区'].report.length" class="mt34 pr item-ol">
              <p class="pr">{{detail["劣势共识区"].report}}</p>
            </div>

            <h3 class="two-title mt34 text-bold">3.3 您的优势盲点区：</h3>
            <div class="tag-row">
              <span v-for="(item3, index) in detail['优势盲点区'].result" :key="index+''">{{item3}}</span>
              <span v-if="detail['优势盲点区'].result.length == 0">（无）</span>
            </div>
            <div v-if="detail['优势盲点区'].report.length" class="mt34 pr item-ol">
              <p class="pr">{{detail["优势盲点区"].report}}</p>
            </div>

            <h3 class="two-title mt34 text-bold">3.4您的劣势盲点区：</h3>
            <div class="tag-row">
              <span v-for="(item4, index) in detail['劣势盲点区'].result" :key="index+''">{{item4}}</span>
              <span v-if="detail['劣势盲点区'].result.length == 0">（无）</span>
            </div>
            <div v-if="detail['劣势盲点区'].report.length" class="mt34 pr item-ol">
              <p class="pr">{{detail["劣势盲点区"].report}}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isMy">
        <!-- 横幅 -->
        <div class="banner-box">
          <div class="banner-title pr text-center">
            <div class="pa ban-header-bg"></div>
            <span class="pr">自评报告</span>
          </div>
          <div class="banner pr text-center">
            <div class="p-l pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <div class="p-r pa foam">
              <span class="pa"></span>
              <span class="pa"></span>
              <span class="pa"></span>
            </div>
            <p>职场可迁移能力报告</p>
          </div>
        </div>
        <!--  -->
      </div>
      <!-- 第一板块 -->
      <div :class="[!isMy ? 'cart-top-move' : '', 'con-cart']">
        <!--  -->
        <div class="intro-1">
          <p>“可迁移能力是我们应对这个变动时代的终极武器。”</p>
          <p class="pt34">
            基于数百份胜任模型的分析，我们归纳出职场可迁移能力的模型，包括
            <span class="bold-yellow" @click="showPops('思维能力')">思维能力</span>、
            <span class="bold-yellow" @click="showPops('人际能力')">人际能力</span>、
            <span class="bold-yellow" @click="showPops('任务管理')">任务管理</span>和
            <span class="bold-yellow" @click="showPops('团队管理')">团队管理</span>四个维度（点击可查看能力详情）共12项能力。
          </p>
          <!-- <h4 class="title-2 pt34">可迁移能力可以从两个视角透析：</h4> -->
          <div class="show-img">
            <img src="@a/admin-ability-1.png" alt />
          </div>
          <!-- 视角 -->
          <!-- 					<div class="visual">
						<div class="pr vis-name">
							<span class="line pa"></span>
							<h4>[视角1 基础vs.管理]</h4>
						</div>
						<div class="">认知能力和人际能力侧重基础能力，而任务管理和团队管理偏向管理能力；</div>
					</div>
					<div class="visual">
						<div class="pr vis-name">
							<span class="line pa"></span>
							<h4>[视角2 对人vs.对事]</h4>
						</div>
						<div class="">认知能力和人际能力侧重基础能力，而任务管理和团队管理偏向管理能力；</div>
          </div>-->
          <!-- 第一部分结尾 -->
          <!-- <p class="cart-footer">本报告基于您的自我报告，解析您的职场可迁移能力 现状。</p> -->
        </div>
      </div>
      <!-- 横幅1 -->
      <div class="banner-box">
        <div class="banner pr text-center">
          <div class="p-l pa foam">
            <span class="pa"></span>
            <span class="pa"></span>
            <span class="pa"></span>
          </div>
          <div class="p-r pa foam">
            <span class="pa"></span>
            <span class="pa"></span>
            <span class="pa"></span>
          </div>
          <p>1、总体得分情况</p>
        </div>
      </div>
      <!-- 第二版块 总体得分情况 -->
      <div class="con-cart">
        <div class="intro-1">
          <p>您在这四个维度的自评情况如下（满分5分）：</p>
          <div class="lin-charts-box charts-box">
            <ve-bar :height="'280px'" :data="myBarChartData1" :settings="allScoreChartStyle"></ve-bar>
          </div>
          <!--  -->
          <p class="pt34">能力排序（从高到低）：</p>
          <div class="tag-row">
            <span v-for="(item,index) in self_result_sort" :key="index">{{item}}</span>
          </div>
        </div>
      </div>
      <!-- 横幅2 -->
      <div class="banner-box">
        <div class="banner pr text-center">
          <div class="p-l pa foam">
            <span class="pa"></span>
            <span class="pa"></span>
            <span class="pa"></span>
          </div>
          <div class="p-r pa foam">
            <span class="pa"></span>
            <span class="pa"></span>
            <span class="pa"></span>
          </div>
          <p>2、优劣势分析</p>
        </div>
      </div>
      <!-- 第三版块 优劣势分析与建议 -->
      <div class="con-cart">
        <div class="intro-1">
          <p>本部分分析了您的相对优势（排名前两位）和相对劣势（排名末两位）。</p>
          <p class="text-yellow text-bold">特别提示：优劣势划分是针对您自身能力的相对划分，并非与他人比较的结果。</p>
          <div class="charts-box radar-charts-box">
            <ve-radar
              :height="'400px'"
              :data="myRadarChartData1"
              :colors="['rgba(255,255,255,0)', '#ED7D32']"
              :settings="radarConfig"
              :extend="radarExtend"
            ></ve-radar>
          </div>
          <div class="visual">
            <div class="pr vis-name">
              <span class="line pa"></span>
              <h4>[2.1 优势发展]</h4>
            </div>
          </div>
          <!-- 笑脸 -->
          <div class="circle-box mt34 pr">
            <div class="cart-top-face text-center pa">
              <img src="@a/cart-top-tip.png" alt />
            </div>
            <span>您的相对优势是：</span>
            <span
              class="cir-tag text-bold text-yellow"
              v-for="(item,index) in self_top2"
              :key="index"
            >{{item}}</span>
          </div>
          <!--  -->
          <div class="public-cart">
            <div
              @click="cartState3 = !cartState3"
              :class="[cartState3 ? 'tr' : '' ,'scroll-ico mt34 text-center scale-1']"
            >
              <img src="@a/down-scroll.png" alt />
            </div>
            <p v-show="!cartState3" class="text-yellow color-animite mt10 text-center">点击查看详情</p>
            <p v-show="cartState3" class="text-yellow color-animite mt10 text-center">点击收起详情</p>
          </div>
          <!-- <div @click="cartState3 = !cartState3" class="mt34 color-animite text-yellow text-center text-bold">点击查看详情</div> -->
          <!--  -->
          <div v-show="cartState3" class="mt34 pr item-ol">
            <p class="pr" v-for="(item,index) in self_report_top" :key="index">{{item}}</p>
          </div>
          <!--  -->
          <div class="visual">
            <div class="pr vis-name">
              <span class="line pa"></span>
              <h4>[2.2 自我提升]</h4>
            </div>
          </div>
          <!-- 笑脸 -->
          <div class="circle-box circle-active mt34 pr">
            <div class="cart-top-face text-center pa">
              <img src="@a/cart-top-tip2.png" alt />
            </div>
            <span>您的相对劣势是：</span>
            <span
              class="cir-tag text-bold text-yellow"
              v-for="(item,index) in self_bottom2"
              :key="index"
            >{{item}}</span>
          </div>
          <!--  -->
          <div class="public-cart">
            <div
              @click="cartState4 = !cartState4"
              :class="[cartState4 ? 'tr' : '' ,'scroll-ico mt34 text-center scale-1']"
            >
              <img src="@a/down-scroll.png" alt />
            </div>
            <p v-show="!cartState4" class="text-yellow color-animite mt10 text-center">点击查看详情</p>
            <p v-show="cartState4" class="text-yellow color-animite mt10 text-center">点击收起详情</p>
          </div>
          <!-- <div @click="cartState4 = !cartState4" class="mt34 color-animite text-yellow text-center text-bold">点击查看详情</div> -->
          <!--  -->
          <div v-show="cartState4" class="mt34 pr item-ol">
            <p class="pr" v-for="(item,index) in self_report_bottom" :key="index">{{item}}</p>
          </div>
        </div>
      </div>
      <!-- 横幅3 -->
      <div class="banner-box">
        <div class="banner-title pr text-center">
          <div class="pa ban-header-bg"></div>
          <span class="pr">进阶评估</span>
        </div>
        <div class="banner pr text-center">
          <div class="p-l pa foam">
            <span class="pa"></span>
            <span class="pa"></span>
            <span class="pa"></span>
          </div>
          <div class="p-r pa foam">
            <span class="pa"></span>
            <span class="pa"></span>
            <span class="pa"></span>
          </div>
          <p>邀请他人评价，全面了解自己</p>
        </div>
      </div>
      <!-- 第四版块 以人为镜，更全面地了解自己 -->
      <div class="con-cart">
        <div class="intro-1">
          <p>
            如果想了解“他人眼中的我”是怎样的，
            <span class="text-yellow">转发下面卡片，邀请熟悉你能力的人为你评价！建议3人以上</span>，越多结果越有参考性。
          </p>
          <div class="intro-1">
            <div class="cart-poster mt34">
              <img :src="ta_poster" alt />
            </div>
          </div>
          <p
            class="text-yellow mt34"
            style="text-align: justify;"
          >您将获得包括“自评和他评对比”、“共识与盲点”等内容的完整报告，部分图示如下</p>
          <div class="mt34 pt34">
            <img src="@a/cart-footer-data.png" alt />
          </div>
          <!--  -->
        </div>
      </div>
      <!-- 横幅 -->
      <!-- <div class="banner-box">
				<div class="banner pr text-center">
					<div class="p-l pa foam">
						<span class="pa"></span>
						<span class="pa"></span>
						<span class="pa"></span>
					</div>
					<div class="p-r pa foam">
						<span class="pa"></span>
						<span class="pa"></span>
						<span class="pa"></span>
					</div>
					<p>能力变现攻略</p>
				</div>
      </div>-->
      <!--9.9职业发展进阶广告位  -->
      <!-- begin 插入广告组件 -->
      <public-advertising class="pdt"></public-advertising>
      <public-ad-qrcode></public-ad-qrcode>

      <!--  -->
      <!------- 七天训练营广告 --------->
      <!-- <div class="con-cart">
				<div class="intro-1 public-cart">
					<div class="mt34">
						<p class="text-yellow text-center mt34">看这里 ↓  ↓  ↓ </p>
					</div>
					<div class="intro-1">
						<img src="@a/img-1-defeft.png" alt="" />
					</div>
					<p class="text-center text-yellow mt34 text-bold">长按上图识别二维码 ↑  ↑  ↑ </p>
					<p class="cart-footer text-center">获取能力使用攻略，成功分享课程还有现金奖励</p>
					<p class="cart-footer text-center">觉得测评不错，点击右上角分享好友</p>
						<div class="scroll-ico mt34 text-center">
						<img src="@a/down-scroll.png" alt="" />
					</div>
				</div>
      </div>-->
      <!-- 横幅2 -->
      <!-- 			<div class="banner-box">
				<div class="banner pr text-center">
					<div class="p-l pa foam">
						<span class="pa"></span>
						<span class="pa"></span>
						<span class="pa"></span>
					</div>
					<div class="p-r pa foam">
						<span class="pa"></span>
						<span class="pa"></span>
						<span class="pa"></span>
					</div>
					<p>能力试炼提升</p>
				</div>
      </div>-->
      <!--  -->
      <!-- 			<div class="con-cart">
				<div class="intro-1">
					<div class="intro-1">
						<img src="@a/img-1-defeft.jpg" alt="" />
					</div>
					<p class="cart-f-title text-yellow text-center mt34">进营提升能力吧!</p>
				</div>
      </div>-->
    </div>
    <!-- 自己 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="lock">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <!-- <img src="../../../assets/cep_ewm.png" /> -->
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt />
        </div>
      </div>
    </van-popup>
    <!-- 弹窗 -->
    <van-popup class="explain" v-model="alertModule">
      <div>
        <div class="pps">{{activeVal}}</div>
      </div>
    </van-popup>
    <!--  -->
    <van-popup class="radius" :close-on-click-overlay="true" v-model="pop_show">
      <div class="pb-public">
        <div class="pop2">
          <p class="mt34" v-for="(item,index) in actPopData" :key="index">
            <span class="text-bold text-yellow">{{item.key}}</span>
            ：{{item.con}}
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { measurement_new_all_report} from "@/api/measurement";
import PublicAdvertising from "@c/measurement/public-advertising";
import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";
import { shareCon } from "@/utils/wxconfig";
export default {
  data() {
    return {
      data: {},
      type_obj: {
        evaluation_id: "",
        evaluation_name: "",
        evaluation_id: "",
        nickname: ""
      },
      tabList: {
        优势盲点区: [],
        优势共识区: [],
        劣势共识区: [],
        劣势盲点区: []
      },
      cartState2: false,
      cartState3: false,
      cartState4: false,
      actPopData: [],
      popData: {
        思维能力: [
          {
            key: "学习领悟",
            con:
              "对新知识保持渴求心态，能主动学习快速获取，并在实践中检验学习效果，通过回顾和反思达到学习目标。"
          },
          {
            key: "问题解决",
            con:
              "能够准确快速地发现问题，利用各种方法和资源，收集、分析相关信息并提出有效解决方案。"
          },
          {
            key: "创新能力",
            con:
              "能够摆脱传统思维和常规经验的束缚，富有想象力和创意，实践中能够创造性地解决问题。"
          }
        ],
        人际能力: [
          {
            key: "沟通能力",
            con:
              "具有很强的表达能力和积极倾听能力，能够准确有效地传递信息，善于主动使用沟通的方式解决问题。"
          },
          {
            key: "团队合作",
            con:
              "具有很强的团队精神和合作意识，时刻从团队利益出发，能够和团队成员融洽相处，齐心协力解决问题，为团队做出巨大贡献。"
          },
          {
            key: "关系管理",
            con:
              "能够与对自己有利的相关人士建立并保持良好关系，形成了完善的人际关系网。"
          }
        ],
        任务管理: [
          {
            key: "协调能力",
            con:
              "面临矛盾与冲突，能够运用恰当的策略进行沟通协调，以缓和或化解矛盾与冲突的能力。"
          },
          {
            key: "高效执行",
            con:
              "持续推进任务的进行，并能够高效率的执行，在过程中能够灵活调整策略，保证任务目标的达成。"
          },
          {
            key: "计划组织",
            con:
              "针对任务情况，能够快速制定行之有效的计划，并合理调配与运用资源，保证任务顺利进行。"
          }
        ],
        团队管理: [
          {
            key: "识人用人",
            con:
              "能够根据员工的能力和个性特点，将其安排到合适的岗位上，在工作中使其扬长避短，实现价值。"
          },
          {
            key: "团队激励",
            con:
              "能够采取有效的方式激发团队成员的工作热情，调动内在动力，提高团队战斗力。"
          },
          {
            key: "发展他人",
            con:
              "工作中有培养他人的意识，通过多种方式指导、帮助其能力和素质的提高。"
          }
        ]
      },
      //
      activeVal: "",
      explanation: {},
      pop_show: false,
      alertModule: false,
      //
      qrcode: "",
      //
      ta_show: false,
      show_body: false,
      // 模式
      isMy: false,
      lock: false,
      //
      starsData: [],
      // 高估低估
      ta_high: [],
      ta_low: [],
      ta_count: 0,
      self_result_sort: [],
      // 结果详情
      detail: {
        优势共识区: {
          result: [],
          report: ""
        },
        劣势共识区: {
          result: [],
          report: ""
        },
        优势盲点区: {
          result: [],
          report: ""
        },
        劣势盲点区: {
          result: [],
          report: ""
        }
      },
      // 优势劣势-发展
      self_report_top: [],
      self_report_bottom: [],
      // 相对优势-劣势
      self_top2: [],
      self_bottom2: [],
      // 自评图片
      self_poster: "",
      ta_poster: "",
      // 雷达通用配置

      // 雷达--1
      taRadarData1: {
        columns: [],
        rows: []
      },

      radarConfig: {
        splitLine: {
          lineStyle: {
            color: ["#F57F17", "rgba(255,255,255, 0)"]
          }
        }
      },
      radarExtend: {
        name: {
          formatter: (text, index) => {
            text = text.replace(/\S{2}/g, function(match) {
              return match + "\n";
            });
            return text;
          }
        }
      },
      taBarConfig: {
        xAxisName: ["自拍", "他评"]
      },
      // 总体评价差异
      taBarData1: {
        columns: ["能力", "自拍", "他评"],
        rows: []
      },
      // 四个
      taBarData2: {
        columns: ["能力", "自拍", "他评"],
        rows: []
      },
      twoRadarResult1: {
        ta_high: false,
        ta_low: false,
        ta_eq: false
      },
      taBarData3: {
        columns: ["能力", "自拍", "他评"],
        rows: []
      },
      twoRadarResult2: {
        ta_high: false,
        ta_low: false,
        ta_eq: false
      },
      taBarData4: {
        columns: ["能力", "自拍", "他评"],
        rows: []
      },
      twoRadarResult3: {
        ta_high: false,
        ta_low: false,
        ta_eq: false
      },
      taBarData5: {
        columns: ["能力", "自拍", "他评"],
        rows: []
      },
      twoRadarResult4: {
        ta_high: false,
        ta_low: false,
        ta_eq: false
      },

      // 自评自己 1 线图
      myBarChartData1: {
        columns: [],
        rows: []
      },
      // 优劣势分析建议
      myRadarChartData1: {
        columns: [],
        rows: []
      },

      allScoreChartStyle: {
        itemStyle: {
          color: "#F57F17"
        }
      }
    }
  },
  components:{
    PublicAdvertising,
    PublicAdQrcode,
    PublicTopTips,
  },
  methods: {
    // 广告跳转
    toViewHandle(link) {
      window.location.href = link;
    },
    showPops(key) {
      this.actPopData = this.popData[key];
      this.pop_show = true;
    },
    showPop(key) {
      this.activeVal = this.explanation[key];
      this.alertModule = true;
    },
    pullData() {
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      measurement_new_all_report().then(data => {
        // loading
        this.$toast.clear();

        if (!data.code) {
          this.data = data;

          this.type_obj.evaluation_id = data.cid;
          this.type_obj.evaluation_name = data.headtitle;
          this.type_obj.evaluation_user_id = data.uid;
          this.type_obj.nickname = data.nickname;
          this.type_obj.path = this.$route.path;
          shareCon("measurement_new", this, this.type_obj);

          this.show_body = true;
          this.qrcode = data.qrcode;
          if (!data.subscribe) {
            this.lock = true;
          }
          if (data.ta_count >= 3) {
            this.isMy = true;
            this.cartState5 = false;
            document.title = "可迁移能力报告（完整版）";
          } else {
            this.isMy = false;
            this.cartState5 = true;
            document.title = "可迁移能力报告（自评版）";
          }

          if (data.ta_count >= 3) {
            // 他评部分总体评价差异
            var taBarData1Rows = [];
            for (let attr in data.ta_result) {
              taBarData1Rows.push({
                能力: attr,
                自评: data.ta_result[attr].self,
                他评: data.ta_result[attr].ta
              });
            }
            this.taBarData1 = {
              columns: ["能力", "自评", "他评"],
              rows: taBarData1Rows
            };

            // 他评高估低估
            this.ta_low = data.ta_low;
            this.ta_high = data.ta_high;

            var taRadarDataCoumns1 = ["能力"]; // key
            var taRadarDataResult1 = [{}, {}, {}]; // val
            taRadarDataResult1[1]["能力"] = "自评";
            taRadarDataResult1[2]["能力"] = "他评";
            taRadarDataResult1[0] = {
              关系管理: 5,
              创新能力: 5,
              协调能力: 5,
              发展他人: 5,
              团队合作: 5,
              学习领悟: 5,
              沟通能力: 5,
              激励他人: 5,
              计划组织: 5,
              识人用人: 5,
              问题解决: 5,
              高效执行: 5
            };
            for (let attr in data.ta_analyse_result) {
              taRadarDataCoumns1.push(attr);
              taRadarDataResult1[1][attr] = data.ta_analyse_result[attr].self;
              taRadarDataResult1[2][attr] = data.ta_analyse_result[attr].ta;
            }
            // 自评他评对比结果
            this.taRadarData1 = {
              columns: taRadarDataCoumns1,
              rows: taRadarDataResult1
            };

            let taBarData2Result = data.analyse_result["思维能力"].ta_result;
            let taBarData2Rows = [];
            for (let attr in taBarData2Result) {
              taBarData2Rows.push({
                能力: attr,
                自评: taBarData2Result[attr].self,
                他评: taBarData2Result[attr].ta
              });
            }
            // 各项能力对比 -- 思维能力
            this.taBarData2 = {
              columns: ["能力", "自评", "他评"],
              rows: taBarData2Rows
            };
            let twoKey1 = data.analyse_result["思维能力"];
            this.twoRadarResult1 = {
              ta_high: twoKey1.ta_high.length ? twoKey1.ta_high : false,
              ta_low: twoKey1.ta_low.length ? twoKey1.ta_low : false,
              ta_eq: twoKey1.ta_eq.length ? twoKey1.ta_eq : false
            };

            let taBarData3Result = data.analyse_result["人际能力"].ta_result;
            let taBarData3Rows = [];
            for (let attr in taBarData3Result) {
              taBarData3Rows.push({
                能力: attr,
                自评: taBarData3Result[attr].self,
                他评: taBarData3Result[attr].ta
              });
            }
            // 各项能力对比 -- 思维能力
            this.taBarData3 = {
              columns: ["能力", "自评", "他评"],
              rows: taBarData3Rows
            };
            let twoKey2 = data.analyse_result["人际能力"];
            this.twoRadarResult2 = {
              ta_high: twoKey2.ta_high.length ? twoKey2.ta_high : false,
              ta_low: twoKey2.ta_low.length ? twoKey2.ta_low : false,
              ta_eq: twoKey2.ta_eq.length ? twoKey2.ta_eq : false
            };

            let taBarData4Result = data.analyse_result["任务管理"].ta_result;
            let taBarData4Rows = [];
            for (let attr in taBarData4Result) {
              taBarData4Rows.push({
                能力: attr,
                自评: taBarData4Result[attr].self,
                他评: taBarData4Result[attr].ta
              });
            }
            // 各项能力对比 -- 思维能力
            this.taBarData4 = {
              columns: ["能力", "自评", "他评"],
              rows: taBarData4Rows
            };
            let twoKey3 = data.analyse_result["任务管理"];
            this.twoRadarResult3 = {
              ta_high: twoKey3.ta_high.length ? twoKey3.ta_high : false,
              ta_low: twoKey3.ta_low.length ? twoKey3.ta_low : false,
              ta_eq: twoKey3.ta_eq.length ? twoKey3.ta_eq : false
            };

            let taBarData5Result = data.analyse_result["团队管理"].ta_result;
            let taBarData5Rows = [];
            for (let attr in taBarData5Result) {
              taBarData5Rows.push({
                能力: attr,
                自评: taBarData5Result[attr].self,
                他评: taBarData5Result[attr].ta
              });
            }
            // 各项能力对比 -- 思维能力
            this.taBarData5 = {
              columns: ["能力", "自评", "他评"],
              rows: taBarData5Rows
            };
            let twoKey4 = data.analyse_result["团队管理"];
            this.twoRadarResult4 = {
              ta_high: twoKey4.ta_high.length ? twoKey4.ta_high : false,
              ta_low: twoKey4.ta_low.length ? twoKey4.ta_low : false,
              ta_eq: twoKey4.ta_eq.length ? twoKey4.ta_eq : false
            };

            // 演出内容提示
            this.explanation = data.explanation;
            // 结果详情
            this.detail = data.detail;

            // this.tabList
            let n1 = data.n1;
            let n2 = data.n2;
            for (let attr in data.ta_analyse_result) {
              let item = data.ta_analyse_result[attr];
              // 优势共识区
              if (item.self >= n1 && item.ta >= n2) {
                this.tabList["优势共识区"].push(attr);
              }
              // 劣势盲点区
              if (item.self >= n1 && item.ta < n2) {
                this.tabList["劣势盲点区"].push(attr);
              }
              // 劣势共识区
              if (item.self < n1 && item.ta < n2) {
                console.log(item);
                this.tabList["劣势共识区"].push(attr);
              }
              // 优势盲点区
              if (item.self < n1 && item.ta >= n2) {
                this.tabList["优势盲点区"].push(attr);
              }
            }
          }

          // 自评 他评 海报
          this.self_poster = data.self_poster;
          this.ta_poster = data.ta_poster;

          // 自评得分
          var taRadarDataResult2 = []; // val
          for (let attr in data.self_result) {
            taRadarDataResult2.push({
              能力: attr,
              自评得分: data.self_result[attr]
            });
          }
          // 自评他评对比结果
          this.myBarChartData1 = {
            columns: ["能力", "自评得分"],
            rows: taRadarDataResult2
          };
          // 自拍结果排序
          this.self_result_sort = data.self_result_sort;
          //
          this.ta_count = data.ta_count;

          let myRadarChartsColum1 = ["能力"];
          let myRadarChartsRows1 = [{}, {}];
          myRadarChartsRows1[1] = {
            能力: "自评"
          };
          for (let attr in data.self_analyse_result) {
            myRadarChartsColum1.push(attr);
            myRadarChartsRows1[1][attr] = data.self_analyse_result[attr];
          }
          myRadarChartsRows1[0] = {
            关系管理: 5,
            创新能力: 5,
            协调能力: 5,
            发展他人: 5,
            团队合作: 5,
            学习领悟: 5,
            沟通能力: 5,
            激励他人: 5,
            计划组织: 5,
            识人用人: 5,
            问题解决: 5,
            高效执行: 5
          };
          this.myRadarChartData1 = {
            columns: myRadarChartsColum1,
            rows: myRadarChartsRows1
          };

          // 优势发展
          this.self_report_top = data.self_report_top;
          // 自我提升
          this.self_report_bottom = data.self_report_bottom;
          //
          this.self_top2 = data.self_top2;
          this.self_bottom2 = data.self_bottom2;
        } else {
          this.$router.push("/measurement_public");
        }
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>
<style lang="scss" scoped>
.bg-pick {
  background: #fbf5f0;
  // padding-bottom: 80px;
}
.pdt{
  background-color: #ffffff;
  margin-top: 30px;
}
.info-img {
  img {
    width: 100%;
    vertical-align: top;
  }
  .poster-tipH {
    font-size: 38px;
    top: 65px;
    left: 30px;
  }
  .poster-tip {
    top: 130px;
    left: 30px;
    font-size: 32px;
  }
}
.mt34 {
  margin-top: 34px;
}
.con-box {
  padding: 0 30px 30px;
  z-index: 1;
  word-wrap: break-word;
}
/* 卡片 */
.cart-top-move {
  transform: translateY(-52px);
  margin-bottom: -52px;
}
.text-yellow {
  color: #f57f17;
}
.text-bold {
  font-weight: bold;
}
.public-cart {
  .scroll-ico {
    transition: all 0.5s;
    transform: rotateZ(0deg);
    img {
      width: 58px;
      height: 58px;
    }
  }
  .tr {
    transform: rotateZ(180deg);
  }
}
.rgb-cart-box {
  margin-top: 100px;
}
.con-cart {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0px 12px rgba(245, 127, 23, 0.2);
  padding: 52px 0;
  .table-data {
    height: 600px;
    border: 1px solid #a1b8e1;
    .coll-t {
      height: 530px;
      border-bottom: 1px solid #a1b8e1;
      display: flex;
      align-content: center;
      > div:nth-child(1) {
        width: 60px;
        position: relative;
        border-right: 1px solid #a1b8e1;
      }
      > div:nth-child(2) {
        flex-grow: 1;
      }
    }
    .table-l-type {
      > div {
        width: 100%;
        height: 50%;
        padding: 0 14px 0 15px;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
      }
      > div:nth-child(1) {
        border-bottom: 1px solid #a1b8e1;
        background: #c9c9c9;
      }
      > div:nth-child(2) {
        background: #ededed;
      }
    }
    .table-con {
      display: flex;
      flex-wrap: wrap;
      > div {
        width: 50%;
        height: 50%;
        position: relative;
        > span {
          position: absolute;
          font-size: 12px;
          color: #666;
        }
        > div {
          padding-top: 50px;
          > p {
            width: 50%;
            text-align: center;
          }
        }
        p {
          margin-top: -5px;
        }
      }
      > div:nth-child(1) {
        background: #ffe699;
        text-align: right;
      }
      > div:nth-child(2) {
        background: #c5e0b4;
        text-align: left;
      }
      > div:nth-child(3) {
        background: #d6dce5;
        text-align: right;
      }
      > div:nth-child(4) {
        background: #f8cbad;
        text-align: left;
      }
      > div:nth-child(1),
      > div:nth-child(2) {
        border-bottom: 1px solid #a1b8e1;
        > span {
          top: 5px;
        }
      }
      > div:nth-child(1),
      > div:nth-child(3) {
        border-right: 1px solid #a1b8e1;
        > span {
          left: 5px;
        }
      }
      > div:nth-child(2),
      > div:nth-child(4) {
        > span {
          right: 5px;
        }
      }
    }
    .coll-b {
      height: 70px;
      line-height: 70px;
      padding-left: 58px;
      text-align: center;
    }
    .coll-b-con {
      display: flex;
      align-content: center;
      height: 100%;
      border-left: 1px solid #a1b8e1;
      > div {
        height: 70px;
        width: 50%;
      }
      > div:nth-child(1) {
        border-right: 1px solid #a1b8e1;
        background: #ededed;
      }
      > div:nth-child(2) {
        background: #c9c9c9;
      }
    }
  }
  /* 线图box */
  .charts-box {
    margin-top: 50px;
  }
  .loss-100 {
    margin-bottom: -100px;
  }
  .lin-charts-box {
    margin-bottom: -120px;
  }
  .radar-charts-box {
    margin-bottom: -80px;
  }
  /* 雷达box */
  .umbrella-charts-box {
  }
  /* 标签卡 */
  .circle-box {
    padding: 50px;
    border: 3px solid #f57f17;
    border-radius: 5px;
    .two-title {
      font-size: 28px;
      color: #333;
      font-weight: bold;
    }
    .cir-tag {
      padding: 0 10px;
      padding-bottom: 10px;
      border-bottom: 2px solid #f57f17;
      margin-right: 30px;
    }
    .cart-top-face {
      background: #fff;
      width: 77px;
      height: 53px;
      right: 41px;
      top: -26.5px;
      img {
        width: 53px;
      }
    }
  }
  .circle-active {
    border-color: #cccccc;
  }
  /*  */
  .item-ol {
    p {
      line-height: 40px;
      margin-top: 14px;
      text-indent: 37px;
    }
    p::after {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      background: #f57f17;
      border-radius: 5px;
      position: absolute;
      left: 2px;
      top: 15px;
    }
  }
  .intro-1 {
    padding: 0 20px;
    font-size: 26px;
    line-height: 42px;
    color: #333;
    img {
      max-width: 100%;
    }
  }

  .pt34 {
    padding-top: 34px;
  }
  .mt34 {
    margin-top: 34px;
  }
  .title-2 {
    color: #222;
    font-weight: bold;
  }
  .bold-yellow {
    color: #f57f17;
    text-decoration: underline;
  }
  .show-img {
    margin-top: 51px;
    img {
      max-width: 100%;
    }
  }
  /*  */
  .visual {
    margin-top: 30px;
    .line {
      top: 50%;
      height: 0;
      left: 0;
      width: 100%;
      border-top: 2px dashed #f57f17;
    }
    .vis-name {
      font-size: 28px;
      color: #f57f17;
      h4 {
        line-height: 54px;
        position: relative;
        display: inline-block;
        z-index: 1;
        background: #fff;
        padding: 0 10px;
      }
    }
  }
  .cart-footer {
    margin-top: 40px;
    font-size: 28px;
    color: #f57f17;
    font-weight: bold;
    line-height: 42px;
  }
  /* */
  .cart-f-title {
    font-size: 34px;
    font-weight: bold;
  }
  /*  */
  .tag-row {
    color: #f57f17;
    padding: 30px 0 0;
    line-height: 60px;
    span {
      margin-right: 20px;
      font-weight: bold;
      padding: 10px 12px;
      border-bottom: 2px solid #f57f17;
      padding-bottom: 10px;
    }
  }
}
.lin-tag {
  font-size: 26px;
  line-height: 60px;
  span {
    padding: 10px;
    font-weight: bold;
    border-bottom: 2px solid #f57f17;
    color: #f57f17;
    margin: 0 10px;
  }
}
/* 横幅 */
.banner-box {
  padding: 80px 0 40px;
  .banner-title {
    margin-bottom: 30px;
    span {
      display: inline-block;
      z-index: 1;
      background: #fbf5f0;
      padding: 0 14px;
      font-size: 34px;
      color: #f57f17;
    }
    .ban-header-bg {
      height: 20px;
      width: 100%;
      background: #f57f17;
      left: 0;
      top: 50%;
      margin-top: -10px;
    }
  }
  .banner {
    margin: 0 auto;
    width: 498px;
    height: 62px;
    background: #f57f17;
    border-radius: 31px;
    font-size: 34px;
    color: #fff;
    line-height: 62px;
  }
  .foam {
    top: 0;
    bottom: 0;
    height: 62px;
    width: 0;
    height: 62px;
    span:nth-child(1) {
      width: 16px;
      height: 16px;
      border-radius: 8px;
      background: #f8a61d;
    }
    span:nth-child(2) {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      background: #f57f17;
    }
    span:nth-child(3) {
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: #f5c917;
    }
  }
  .p-l {
    left: 0;
    span:nth-child(1) {
      top: 27px;
      left: -4px;
    }
    span:nth-child(2) {
      top: 18px;
      left: -18px;
    }
    span:nth-child(3) {
      top: 41px;
      left: -18px;
    }
  }
  .p-r {
    right: 0;
    span:nth-child(1) {
      top: 35px;
      right: -4px;
    }
    span:nth-child(2) {
      top: 44px;
      right: -18px;
    }
    span:nth-child(3) {
      top: 21px;
      right: -18px;
    }
  }
}
.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #f57f17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}
/* 弹窗 */
.explain {
  width: changeRem(13) + px;
  height: auto;
  border-radius: changeRem(0.16) + px;
  background: #fff;
  text-align: center;
  padding: changeRem(0.8) + px changeRem(1.2) + px;
  h2 {
    text-align: justify;
    margin-top: 0;
    font-size: changeRem(0.64) + px;
    color: #eb5032;
    font-weight: normal;
    margin-bottom: changeRem(0.2) + px;
  }
  .pps {
    color: #333;
    font-size: changeRem(0.52) + px;
    line-height: changeRem(0.8) + px;
    text-align: justify;
  }
}
.radius {
  border-radius: 15px;
  text-align: justify;
  .pb-public {
    width: 8rem;
    padding: 40px;
  }
}
.scale-1 {
  img {
    transform: scale(0.7);
  }
}
.color-animite {
  animation: color-animite 2s infinite;
}
.career-dev {
  background-color: #ffffff;
  margin-top: 20px;
  .More-main {
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 12px;
    padding: 40px;
    .title {
      text-align: center;
      margin-bottom: 30px;
      font-size: 36px;
      color: #333333;
    }
    ul {
      display: flex;
      flex-direction: column;
      li {
        display: flex;
        img {
          width: 282px;
          height: 176px;
          margin-right: 50px;
        }
        .flex-text {
          flex: 1;
          h3 {
            font-weight: bold;
            font-size: 32px;
            line-height: 40px;
            text-align: left;
            color: #333333;
          }
          a {
            display: block;
            border-radius: 25px;
            background-color: #eb5032;
            color: #ffffff;
            width: 188px;
            line-height: 50px;
            margin-top: 15px;
            font-size: 26px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
<style>
@keyframes color-animite {
  0% {
    color: #f57f17;
  }
  50% {
    color: red;
  }
  100% {
    color: #f57f17;
  }
}
.bg-pick .show-img img {
  max-width: 100%;
  vertical-align: top;
}
</style>